module.exports = __webpack_public_path__ + "2b8761e716ae54b1551857f4b194c403.png";